import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/layout/DashboardLayout';
import HomepageBuilder from './pages/HomepageBuilder';
import ContentWizard from './pages/ContentWizard';
import MediaLibrary from './pages/MediaLibrary';
import AiJobs from './pages/AiJobs';
import HeritageTree from './pages/HeritageTree';
import Login from './pages/Login';
import Analytics from './pages/Analytics';
import SearchResults from './pages/SearchResults';
import DataMigration from './pages/DataMigration';
import Settings from './pages/Settings';
import VodManager from './pages/VodManager';
import VodStories from './pages/VodStories';
import VodChannels from './pages/VodChannels';
import ApiDocs from './pages/ApiDocs';
import LiveTvManager from './pages/LiveTvManager';
import MovieManager from './pages/MovieManager';
import MoviesSeriesList from './pages/MoviesSeriesList';
import MusicManager from './pages/MusicManager';

// Protected route wrapper
const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem('jwt_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

import DashboardHome from './pages/DashboardHome';
import VodBulkImport from './pages/VodBulkImport';

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected Routes */}
        <Route path="/" element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }>
          <Route index element={<DashboardHome />} />
          <Route path="homepage-builder" element={<HomepageBuilder />} />
          <Route path="content" element={<ContentWizard />} />
          <Route path="vod-stories" element={<VodStories />} />
          <Route path="vod/channels" element={<VodChannels />} />
          <Route path="vod/new" element={<VodManager />} />
          <Route path="vod/:cuid" element={<VodManager />} />
          
          <Route path="movies-series" element={<MoviesSeriesList />} />
          <Route path="movies/new" element={<MovieManager />} />
          <Route path="movies/:cuid" element={<MovieManager />} />
          
          <Route path="movies/bulk-import" element={<VodBulkImport />} />
          <Route path="iptv" element={<LiveTvManager />} />
          <Route path="music" element={<MusicManager />} />
          <Route path="media" element={<MediaLibrary />} />
          <Route path="ai-jobs" element={<AiJobs />} />
          <Route path="heritage" element={<HeritageTree />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="search" element={<SearchResults />} />
          <Route path="migration" element={<DataMigration />} />
          <Route path="settings" element={<Settings />} />
          <Route path="api-docs" element={<ApiDocs />} />
        </Route>
      </Routes>
    </Router>
  );
}
